import ArchiveIcon from "@mui/icons-material/Archive";
import { Alert, IconButton, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useState } from "react";
import { ConfirmationDialog } from "../../App/Components/ConfirmationDialog/ConfirmationDialog";
import { ICampaignFormState } from "../../App/Typings/Campaigns";
import { DisplayLabelHistory } from "./FieldEditModal";

interface FieldArchiveActionProps {
  fieldId: string;
  disabled: boolean;
}

export default function FieldArchiveAction({ fieldId, disabled }: FieldArchiveActionProps) {
  const { values, setFieldValue } = useFormikContext<ICampaignFormState>();
  const fieldValues = values?.formFields[fieldId];
  const fieldHistoricLabels = values?.labelHistory[fieldId] || new Set<string>();
  const [showArchiveDialog, setShowArchiveDialog] = useState<boolean>(false);

  const archiveClick = (id: string) => {
    const field = { ...fieldValues };
    field.archived = true;

    setFieldValue(`formFields.${id}`, field);
  };

  return (
    fieldValues && (
      <>
        <IconButton
          data-test="archive-field-button"
          aria-label={`archive field`}
          title={"Archive field"}
          sx={{ border: "1px solid", borderRadius: ".2em", marginLeft: ".5em" }}
          color="error"
          onClick={() => setShowArchiveDialog(true)}
          disabled={disabled}
        >
          <ArchiveIcon />
        </IconButton>
        <ConfirmationDialog
          handleCancel={() => setShowArchiveDialog(false)}
          handleConfirm={() => archiveClick(fieldId)}
          handleClose={() => setShowArchiveDialog(false)}
          key="archive-cancel"
          cancelMessage="Cancel"
          confirmMessage="Archive Field"
          isOpen={showArchiveDialog}
          message={
            <>
              <Alert severity="info" sx={{ mb: 2 }}>
                <strong>Notice:</strong> Archiving a field is reversible, here is what will happen:
              </Alert>
              <Typography component="p" gutterBottom>
                Archiving this field will:
              </Typography>
              <ul>
                <Typography component="li" sx={{ mb: 1 }}>
                  Preserve existing candidate data associated with this field
                </Typography>
                <Typography component="li" sx={{ mb: 1 }}>
                  Preserve current field settings and options
                </Typography>
                <Typography component="li" sx={{ mb: 1 }}>
                  Hide the field from Edit Form page
                </Typography>
                <Typography component="li" sx={{ mb: 1 }}>
                  Hide the field by default in search filters and dynamic groups configuration within the CRM.
                  Visibility can be toggled in those areas if needed.
                </Typography>
              </ul>
              <DisplayLabelHistory currentLabel={fieldValues.label} labelHistory={fieldHistoricLabels} />
            </>
          }
          title={`Archive Field: ${fieldValues.fieldName} (${fieldValues.label})`}
          buttonColor="success"
        />
      </>
    )
  );
}
